import * as Yup from "yup";

export const ValidationSchema = (translate: Function) => {

    const mobileNumberRequired: string = translate('settings.contact.mobilenumber.label.error');
    const countryISDCodeRequired: string = translate('settings.contact.mobilenumber.label.error');

    const currentPasswordRequired: string = translate('settings.password.oldpassword.label.error');
    const newPasswordRequired: string = translate('settings.password.newpassword.label.error');
    const oldAndNewSamePassword: string = translate('settings.password.newpassword.match.oldpassword.error');
    const confirmPasswordRequired: string = translate('settings.password.empty.confirmPassword.label.error');
    const confirmPasswordNotMatched: string = translate('settings.password.confirmPassword.label.error');

    const addressLine1Required: string = translate('settings.address.addressline.label.error');
    const cityRequired: string = translate('settings.address.town.label.error');
    const stateRequired: string = translate('settings.address.state.label.error');
    const postCodeRequired: string = translate('settings.address.postcode.label.error');
    const countryRequired: string = translate('settings.address.country.label.error');

    const mobileNumberRegex: RegExp = /^([0-9]{8,14})$/i;
    const countryISDCodeRegex: RegExp = /^((\+){1}([ 0-9]{1,3}))$/i;
    const newPasswordRegex: RegExp = /^(?=.*\d)(?=.*[!@#$%^&*()])(?=.*[a-z])(?=.*[A-Z])[a-zA-Z\d!@#$%^&*()]{10,16}$/;
    const addressLineNo1Regex: RegExp = /^[\S\s]{2,255}$/;
    const cityRegex: RegExp = /^[\S\s]{1,40}$/;
    const stateRegex: RegExp = /^[\S\s]{1,80}$/;
    const postCodeRegex: RegExp = /^([0-9a-zA-Z- \S\s]{3,20})$/;

    const shouldNotEmpty = (value) => value && value.trim().length > 0;

    return Yup.object().shape({
        contactDetails: Yup.object().shape({
            mobileNumber: Yup.string().required(mobileNumberRequired).matches(mobileNumberRegex, mobileNumberRequired),
            countryISDCode: Yup.string().required(countryISDCodeRequired).matches(countryISDCodeRegex, countryISDCodeRequired)
        }),
        isEditPassword: Yup.boolean(),
        currentPassword: Yup.string().when('isEditPassword', {
            is: (isEditPassword: boolean) => {
                return isEditPassword;
            },
            then: Yup.string().required(currentPasswordRequired),
        }),
        newPassword: Yup.string().when('isEditPassword', {
            is: (isEditPassword: string) => {
                return isEditPassword;
            },
            then: Yup.string().required(newPasswordRequired)
                .matches(newPasswordRegex, newPasswordRequired)
        }).when('isSamePassword', {
            is: (isSamePassword: boolean) => {
                return isSamePassword;
            },
            then: Yup.string().required(oldAndNewSamePassword)
        }),
        confirmPassword: Yup.string().when('isEditPassword', {
            is: (isEditPassword: boolean) => {
                return isEditPassword;
            },
            then: Yup.string().required(confirmPasswordRequired)
                .oneOf([Yup.ref('newPassword'), null], confirmPasswordNotMatched),
        }),
        address: Yup.object().shape({
            addressLineNo1: Yup.string()
                .required(addressLine1Required)
                .matches(addressLineNo1Regex, addressLine1Required)
                .test('is-non-empty', addressLine1Required, shouldNotEmpty),
            city: Yup.string()
                .required(cityRequired)
                .matches(cityRegex, cityRequired)
                .test('is-non-empty', cityRequired, shouldNotEmpty),
            state: Yup.string().when('country', {
                is: (country: string) => {
                    return country?.trim().toLowerCase() === 'usa';
                },
                then: Yup.string()
                    .required(stateRequired)
                    .matches(stateRegex, stateRequired)
                    .test('is-non-empty', stateRequired, shouldNotEmpty),
            }),
            postCode: Yup.string()
                .required(postCodeRequired)
                .matches(postCodeRegex, postCodeRequired)
                .test('is-non-empty', postCodeRequired, shouldNotEmpty),
            country: Yup.string().required(countryRequired)
        })
    });
}
